import {PageConfigTypes} from "app/types/PageTypes";
import SalePage from "./SalePage";
import { ROLES } from "app/constants/roles";
import SalesList from "./SalesList";

const SalePageConfig: PageConfigTypes = {
  baseRoute: {
    path: '/sale',
    exact: true,
    component: SalePage,
    authorities: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER,ROLES.ROLE_AGENT]
  },
subRoutes: [
  { path: "/sale/list", component: SalesList },
],

  settings: {}
}

export default SalePageConfig;
